import { useEffect, useState } from 'react';
import { getCookie } from 'cookies-next';

type CookieConsentValue = 'f' | 'fa' | 'fm' | 'fam' | null;

const getCookieConsentValue = (tenant: string): CookieConsentValue => {
  const value = getCookie(`cb-${tenant}-consent`);
  return (value as CookieConsentValue) ?? null;
};

export const useCookieConsentValue = (tenant: string) => {
  const [cookieConsentValue, setCookieConsentValue] = useState<CookieConsentValue>(null);

  useEffect(() => {
    setCookieConsentValue(getCookieConsentValue(tenant));
  }, [tenant]);

  return cookieConsentValue;
};
